/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown> }} Sales_Return_History_DefectInputs */

const vi_sales_return_history_defect = /** @type {(inputs: Sales_Return_History_DefectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`lỗi ${i?.qty}`)
};

/**

* @param {Sales_Return_History_DefectInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_history_defect = /** @type {((inputs: Sales_Return_History_DefectInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_History_DefectInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_history_defect(inputs)
});